import React, { useMemo } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import { isStudioSite } from '@/utils';

import settingsParams from 'AiAssistantWidget/settingsParams';
import { useWidgetSettings } from 'AiAssistantWidget/Widget/contexts';

import { st, classes, cssStates } from './Container.st.css';
import { ContainerDataHooks } from './ContainerDataHooks';

type ContainerProps = {
  children: React.ReactNode;
  ariaBusy?: boolean;
  dialogId?: string;
};

export const Container = ({ children, ariaBusy, dialogId }: ContainerProps) => {
  const { isEditor, isMobile } = useEnvironment();
  const settings = useWidgetSettings();
  const isLeftLayout = useMemo(
    () => settings.get(settingsParams.layout, 'primary') === 'left',
    [settings],
  );

  const noAdsBanner = isEditor || (isMobile && !isStudioSite());

  return (
    <div
      className={st(
        classes.root,
        cssStates({
          left: isLeftLayout,
          hasShadow: settings.get(settingsParams.applyShadow, 'primary'),
          isEditor,
          isMobile,
        }),
      )}
      // TODO: check why settings `top` doesn't work in `st.css` file
      style={noAdsBanner ? {} : { top: 'var(--wix-ads-height)' }}
      data-hook={ContainerDataHooks.ROOT}
      aria-busy={Boolean(ariaBusy)}
      role="dialog"
      aria-modal="false"
      aria-labelledby={dialogId}
    >
      <div className={st(classes.wrapper, classes.overscrollHack)}>
        {children}
      </div>
    </div>
  );
};
